import MissionEvent from './MissionEvent';

export default MissionEvent;
